require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/angular-sanitize/index.js
// module id = 1136
// module chunks = 2